import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";
import ImageText3 from "../components/ImageText3";
import RichText from "../components/RichText";

import video from "../assets/videos/popsbangs.mp4";
import imageurl1 from "../assets/images/popsbangs1.png";
import imageurl2 from "../assets/images/popsbangs2.png";
import video2 from "../assets/videos/service2.mp4";

function PopsBangs() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        Pops &Bangs*heeft zijn naam te danken aan het knallende geluid dat uit
        de uitlaat komt. Deze service staat ook wel bekend als Anti-Lag System
        (ALS) of als Exhaust Crackle. Bij deze service blijft de turbo in
        werking wanneer het gaspedaal niet ingedrukt is. Hierdoor zal uw
        voertuig over een snellere reactietijd en over een hoger vermogen
        beschikken. Wanneer het gaspedaal wordt losgelaten zal de brandstof
        ontploffen in de uitlaat van het voertuig, wat een knallend geluid met
        zich meebrengt.
      </p>
      <br />
      <p className="text-white text-lg">
        In sommige gevallen kan dit ook vlammen uit de uitlaat geven. Alles
        wordt binnen de veiligheidsmarges uitgevoerd. Hoe beter de onderdelen op
        je auto zijn, des te meer mogelijkheden er zijn! In sommigegevallen
        adviseren wij meerdere aanpassingen bij het afnemen van de service Pops
        &Bangs/Burble Tune.
      </p>
    </>
  );

  const text2 = (
    <>
      <p className="text-white text-lg">
        Pops &Bangs*is opzekere hoogte veilig, als er op een verantwoorde manier
        gebruik van wordt gemaakt. Bij onjuist of overmatig gebruik kan het op
        lange termijn wel schadelijk zijn voor de motor en turbo. Het is van
        belang om deze service bij een professionele tuner af te nemen en
        daarvoor bent u bij ons aan het juiste adres. Door middel van onze
        expertise proberen wij u ten alle tijde het juiste advies met betrekking
        tot onze diensten te geven.
      </p>
    </>
  );

  const text3 = (
    <>
      <p className="text-white text-lg">
        {" "}
        Heeft u vragen over deze service of wilt u weten of uw voertuig hiervoor
        in aanmerking komt? Wij zijn telefonisch bereikbaar of middels ons
        contactformulier
      </p>
      <br />
      <h3 className="text-[#BD0E0E] text-xl">LET OP!</h3>
      <br />
      <p className="text-white text-lg">
        U dient een downpipe zonder katalysator te monteren op uw auto!
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="POPS & BANGS" />
      <ImageText2
        heading="Pops&Bangs / Burble Tune"
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <ImageText3
        heading="Deveiligheid van Pops & Bangs"
        text={text2}
        imageUrl={imageurl2}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <RichText text={text3} />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default PopsBangs;
